import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum DevoDonorsPageTabId {
	Donors = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DevoDonorsPageViewId {
	Donors = 1,
	Contacts = 2,
	Gifts = 3,
}


@Injectable({ providedIn: 'root' })
export class DevoDonorsPageService extends PageTabsLayoutPageService<DevoDonorsPageTabId, DevoDonorsPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, DevoDonorsPageViewId>[] = [
		{
			uniqueId: DevoDonorsPageViewId.Donors,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Donors',
				hideText: 'never',
			},
			customSort: '1'
		},
		{
			uniqueId: DevoDonorsPageViewId.Contacts,
			iconContext: {
				iconClass: 'fa-people-group',
				iconStyle: 'fa-solid',
				text: 'Contacts',
				hideText: 'never',
			},
			customSort: '2'
		},
		{
			uniqueId: DevoDonorsPageViewId.Gifts,
			iconContext: {
				iconClass: 'fa-people-group',
				iconStyle: 'fa-solid',
				text: 'Gifts',
				hideText: 'never',
			},
			customSort: '3'
		},
	];

	constructor() {
		super(DevoDonorsPageService._viewDroplistItems, DevoDonorsPageService.name, DevoDonorsPageTabId.Donors, DevoDonorsPageViewId.Donors);
	}

	public get viewId() {
		return DevoDonorsPageViewId;
	}

}